<template>
  <div id="cartInfo" :class="showCartInfo?'show':''" @click.stop="closeCartInfo">
    <div :class="showCartInfo?'cart show':'cart'" @click.stop>
    <!-- <div :class="showCartInfo?'cart show':'cart'" @click.stop> -->
      <div class="cart-info" v-if="showCartInfo">
        <span class="table-info" v-if="showType!='packageTotalSales'&&showType!='empSalesInfo'&&showType!='secondActivity'">{{nowSelName}}-{{titInfo[showType]}}</span>
        <span class="table-info" v-if="showType=='packageTotalSales'">{{nowPackageTotalSalesInfo.packName}}</span>
        <span class="table-info" v-if="showType=='empSalesInfo'">员工姓名:{{nowEmpSalesInfo.empName}}</span>
        <span class="table-info" v-if="showType=='secondActivity'">优惠详情</span>
        <span class="close" @click.stop="closeCartInfo">
          <i class="iconfont icon-guanbi1"></i>
        </span>
      </div>
      <div class="cart-info" v-if="showType=='orderInfo'&&showCartInfo">
        <span class="table-info">{{`${orderInfo.transaction.partitionName}-${orderInfo.transaction.numName}`}}</span>
        <span class="close" @click.stop="closeCartInfo">
          <i class="iconfont icon-guanbi1"></i>
        </span>
      </div>
      <div class="common-wrap">
        <div class="cart-detail" v-if="showType=='secondActivity'&&showCartInfo">
            <div class="cart-detail-item">
              <span class="item-tit">活动名称</span>
              <span class="item-cont">{{secondInfo.name}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">创建时间</span>
              <span class="item-cont">{{secondInfo.addTime | dateForGradePage}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">优惠方式</span>
              <span class="item-cont">{{typeOptions[secondInfo.discountType]}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">减免金额/折扣</span>
              <span class="item-cont">{{formatDiscount(secondInfo)}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">生效时间</span>
              <span class="item-cont">{{formatTime(secondInfo)}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">时间范围</span>
              <span class="item-cont">{{formatTimeRange(secondInfo)}}</span>
            </div>
            <div class="cart-detail-item all-width">
              <span class="item-tit">星期</span>
              <span class="item-cont">{{secondInfo.week}}</span>
            </div>
        </div>
        <div class="cart-detail" v-if="showType=='vipChargeInfo'&&showCartInfo">
            <div class="cart-detail-item">
              <span class="item-tit">充值单号:</span>
              <span class="item-cont">{{vipInfo.orderCode}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">充值时间:</span>
              <span class="item-cont">{{vipInfo.chargeTime | dateForGradePage}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">会员卡号:</span>
              <span class="item-cont">{{vipInfo.memberCode}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">会员姓名:</span>
              <span class="item-cont">{{vipInfo.memberName}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">会员级别:</span>
              <span class="item-cont">{{vipInfo.memberLevel}}</span>
            </div>
             <div class="cart-detail-item">
              <span class="item-tit">会员手机:</span>
              <span class="item-cont">{{vipInfo.memberMobile}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">充前余额:</span>
              <span class="item-cont">{{vipInfo.beforeAmount.toFixed(2)}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">充值金额:</span>
              <span class="item-cont">{{vipInfo.chargeAmount.toFixed(2)}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">赠送金额:</span>
              <span class="item-cont">{{vipInfo.bonusAmount.toFixed(2)}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">会员余额:</span>
              <span class="item-cont">{{vipInfo.afterAmount.toFixed(2)}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">备注:</span>
              <span class="item-cont">{{vipInfo.notice}}</span>
            </div>
            <!-- <div class="cart-detail-item">
              <span class="item-tit">积分兑换:</span>
              <span class="item-cont">{{vipInfo.afterAmount}}</span>
            </div> -->
        </div>
        <div class="cart-detail" v-if="showType=='empSalesInfo'&&showCartInfo">
            <div class="cart-detail-item">
              <span class="item-tit">开始时间:</span>
              <span class="item-cont">{{nowEmpSalesInfo.beginTime}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">结束时间:</span>
              <span class="item-cont">{{nowEmpSalesInfo.endTime}}</span>
            </div>
        </div>
        <div class="cart-detail" v-if="showType=='deskSalesInfo'&&showCartInfo">
            <div class="cart-detail-item">
              <span class="item-tit">开台时间:</span>
              <span class="item-cont">{{nowDeskSalesInfo.begin | dateForGradePage}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">关台时间:</span>
              <span class="item-cont">{{nowDeskSalesInfo.end | dateForGradePage}}</span>
            </div>
            <div class="cart-detail-item" v-if="nowDeskSalesInfo.memberName">
              <span class="item-tit">会员姓名:</span>
              <span class="item-cont">{{nowDeskSalesInfo.memberName}}</span>
            </div>
            <div class="cart-detail-item" v-if="nowDeskSalesInfo.memberMobile">
              <span class="item-tit">会员手机号:</span>
              <span class="item-cont">{{nowDeskSalesInfo.memberMobile}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">累计时长:</span>
              <span class="item-cont">{{nowDeskSalesInfo.totalTime}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">顾客人数:</span>
              <span class="item-cont">{{nowDeskSalesInfo.people}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">开单员工:</span>
              <span class="item-cont">{{nowDeskSalesInfo.openEmp}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">商品消费:</span>
              <span class="item-cont">{{nowDeskSalesInfo.totalAmount}}元</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">包间费:</span>
              <span class="item-cont">{{nowDeskSalesInfo.totalRoomAmount}}元</span>
            </div>
        </div>
        <div class="cart-detail" v-if="showType=='vipConsume'&&showCartInfo">
            <div class="cart-detail-item">
              <span class="item-tit">结账编号:</span>
              <span class="item-cont">{{vipConsumeInfo.order.code}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">开单员工:</span>
              <span class="item-cont">{{vipConsumeInfo.order.creatorName}}</span>
            </div>
            
            <div class="cart-detail-item">
              <span class="item-tit">开单时间:</span>
              <span class="item-cont">{{vipConsumeInfo.order.addTime | dateForGradePage}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">结账时间:</span>
              <span class="item-cont">{{vipConsumeInfo.order.paymentTime | dateForGradePage}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">累积时长:</span>
              <span class="item-cont">{{vipConsumeInfo.transaction.inTime}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit"></span>
              <span class="item-cont"></span>
            </div>
             <div class="cart-detail-item">
              <span class="item-tit">顾客人数:</span>
              <span class="item-cont">{{vipConsumeInfo.transaction.people}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">结账员工:</span>
              <span class="item-cont">{{vipConsumeInfo.order.payName}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">会员编号:</span>
              <span class="item-cont">{{vipConsumeInfo.order.memberName}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">会员姓名:</span>
              <span class="item-cont">{{vipConsumeInfo.order.memberName}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">是否免单:</span>
              <span class="item-cont">{{vipConsumeInfo.order.mode==1?"是":"否"}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">是否挂单:</span>
              <span class="item-cont">{{vipConsumeInfo.order.mode==2?"是":"否"}}</span>
            </div>
            <!-- <div class="cart-detail-item">
              <span class="item-tit">积分兑换:</span>
              <span class="item-cont">{{vipInfo.afterAmount}}</span>
            </div> -->
        </div>
        <div class="cart-detail" v-if="showType=='orderInfo'&&showCartInfo">
            <div class="cart-detail-item">
              <span class="item-tit">结账编号:</span>
              <span class="item-cont">{{orderInfo.order.id}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">开单员工:</span>
              <span class="item-cont">{{orderInfo.transaction.empName}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">开单时间:</span>
              <span class="item-cont">{{new Date(orderInfo.order.addTime).Format('yyyy-MM-dd hh:mm:ss')}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">结账时间:</span>
              <span class="item-cont">{{new Date(orderInfo.order.paymentTime).Format('yyyy-MM-dd hh:mm:ss')}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">累计时长:</span>
              <span class="item-cont">{{orderInfo.transaction.inTime}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit"> </span>
              <span class="item-cont"> </span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">顾客人数:</span>
              <span class="item-cont">{{orderInfo.transaction.people}}人</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">结账员工:</span>
              <span class="item-cont">{{orderInfo.order.payName}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">会员编号:</span>
              <span class="item-cont">{{orderInfo.order.memberId?orderInfo.order.memberId:"-"}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">会员姓名:</span>
              <span class="item-cont">{{orderInfo.order.memberId?orderInfo.order.memberName:"-"}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">是否免单:</span>
              <span class="item-cont">{{orderInfo.order.mode == 1?'是':'否'}}</span>
            </div>
            <div class="cart-detail-item">
              <span class="item-tit">是否挂单:</span>
              <span class="item-cont">{{orderInfo.order.mode == 2?'是':'否'}}</span>
            </div>
            <!-- <div class="stamp-img" v-if="showCartInfo&&orderInfo.order.mode!=0">
              <img :src="`./../../../static/image/${modeImg[orderInfo.order.mode]}.png`" alt="">
            </div> -->
        </div>
        
        <div data-v-1e65f96a="" class="split-line" v-if="showType!='packageTotalSales'"></div>
        <div class="note" v-if="showType=='orderInfo'&&showCartInfo">
          <span>备注：{{orderInfo.order.notes?orderInfo.order.notes:'无'}}</span>
        </div>
       
        <div class="cart-goods-detail">
          <div class="info-wrap" v-if="showType=='secondActivity'&&showCartInfo">
            <div class="order-info-wrap">
              <div class="wrap-tit">参与优惠的商品</div>
              <div class="order-info">
                <table>
                  <tr class="head">
                    <th style="width:20%;">排序</th>
                    <th style="width:40%;">商品名</th>
                    <th style="width:20%;">提成金额</th>
                    <th style="width:20%;">销售数量</th>
                  </tr>
                  <tr v-for="(item,index) in goodsInfoForSecond.content" :key="index">
                    <td style="width:20%;">{{index+1}}</td>
                    <td style="width:40%;">{{item.productName}}</td>
                    <td style="width:20%;">{{item.discountCommission / 100}}</td>
                    <td style="width:20%;">{{item.count}}</td>
                  </tr>
                </table>
                <div class="pagination">
                    <el-pagination @current-change="handleCurrentChange" :current-page.sync="nowPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="totalElements">
                    </el-pagination>
                </div>
              </div>
            </div>
          </div>
          <div class="info-wrap" v-if="showType=='secondActivity'&&showCartInfo">
            <div class="order-info-wrap">
              <div class="wrap-tit">活动日志</div>
              <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="时间选择:">
                  <el-date-picker
                  v-model="formInline.startTime"
                  type="datetime"
                  class="dateTime"
                  default-time="00:00:00"
                  placeholder="开始时间">
                  </el-date-picker>
                  <span>至</span>
                  <el-date-picker
                  v-model="formInline.endTime"
                  type="datetime"
                  class="dateTime"
                  default-time="23:59:59"
                  placeholder="结束时间">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
              </el-form>
              <div class="order-info">
                <table>
                  <tr class="head">
                    <th style="width:20%;">消费单号</th>
                    <th style="width:20%;">销售时间</th>
                    <th style="width:40%;">商品名称</th>
                    <th style="width:20%;">销售数量</th>
                  </tr>
                  <tr v-for="(item,index) in salesGoodsInfo.content" :key="index">
                    <td style="width:20%;">{{item.orderId}}</td>
                    <td style="width:20%;">{{item.payTime | numberToAllDate}}</td>
                    <td style="width:40%;">{{item.productName}}</td>
                    <td style="width:20%;">{{item.qty}}</td>
                  </tr>
                </table>
                <div class="pagination">
                    <el-pagination @current-change="handleCurrentChangeForSales" :current-page.sync="nowPageForSales" :page-size="pageSizeForSales" layout="prev, pager, next, jumper" :total="totalElementsForSales">
                    </el-pagination>
                </div>
              </div>
            </div>
          </div>
          <div class="info-wrap" v-if="showType=='vipChargeInfo'&&showCartInfo">
            <div class="order-info-wrap">
              <div class="order-info">
                <table>
                  <tr class="head">
                    <th style="width:50%;">付款方式</th>
                    <th style="width:50%;">金额(元)</th>
                  </tr>
                  <tr>
                    <td style="width:50%;">{{channelType[vipInfo.channel]}}</td>
                    <td style="width:50%;">{{vipInfo.chargeAmount}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="info-wrap" v-if="showType=='vipConsume'&&showCartInfo">
            <div class="order-info-wrap">
              <div class="wrap-tit">收入明细</div>
              <div class="order-info">
                <table>
                  <tr class="head">
                    <th style="width:33.33%;">名称</th>
                    <th style="width:33.33%;">金额(元)</th>
                    <th style="width:33.33%;">优惠</th>
                  </tr>
                  <tr>
                    <td style="width:33.3%;">商品费</td>
                    <td style="width:33.3%;">{{(vipConsumeInfo.productAmount).toFixed(2)}}</td>
                    <td style="width:33.3%;">{{(vipConsumeInfo.productDiscount).toFixed(2)}}</td>
                  </tr>
                  <tr>
                    <td style="width:33.3%;">包间费</td>
                    <td style="width:33.3%;">{{(vipConsumeInfo.transaction.roomAmount).toFixed(2)}}</td>
                    <td style="width:33.3%;">{{(vipConsumeInfo.transaction.roomDiscount).toFixed(2)}}</td>
                  </tr>
                  <tr>
                    <td style="width:33.3%;">服务费</td>
                    <td style="width:33.3%;">{{(vipConsumeInfo.transaction.serviceAmount).toFixed(2)}}</td>
                    <td style="width:33.3%;">{{(vipConsumeInfo.transaction.serviceDiscount).toFixed(2)}}</td>
                  </tr>
                  <tr>
                    <td style="width:33.3%;">手动优惠</td>
                    <td style="width:33.3%;">{{(vipConsumeInfo.order.allHandDiscount).toFixed(2)}}</td>
                    <td style="width:33.3%;">--</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="order-info-wrap">
              <div class="wrap-tit">消费明细</div>
              <div class="order-info">
                <table>
                  <tr class="head">
                    <th style="width:12.5%;">名称</th>
                    <th style="width:12.5%;">数量</th>
                    <th style="width:12.5%;">单价</th>
                    <th style="width:12.5%;">金额</th>
                    <th style="width:12.5%;">点单员工</th>
                    <th style="width:12.5%;">状态</th>
                    <th style="width:25%;">点单时间</th>
                  </tr>
                   <tr v-for="(item,index) in vipConsumeInfo.order.items" :key="index">
                    <td style="width:12.5%;">{{item.productName}}</td>
                    <td style="width:12.5%;">{{item.quantity}}</td>
                    <td style="width:12.5%;">{{item.onePrice}}</td>
                    <td style="width:12.5%;">{{item.dealPrice}}</td>
                    <td style="width:12.5%;">{{item.createName}}</td>
                    <td style="width:12.5%;">{{vipConsumeInfo.order.mode==0?'正常':(vipConsumeInfo.order.mode==1?'免单':'挂单')}}</td>
                    <td style="width:25%;">{{new Date(item.addTime).Format('yyyy-MM-dd hh:mm:ss')}}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="order-info-wrap">
              <div class="wrap-tit">付款信息</div>
              <div class="order-info">
                <table>
                  <tr class="head">
                    <th style="width:50%;">支付方式</th>
                    <th style="width:50%;">金额</th>
                  </tr>
                  <tr>
                    <td style="width:50%;">{{channelType[vipConsumeInfo.order.channel]}}</td>
                    <td style="width:50%;">{{(vipConsumeInfo.order.amount).toFixed(2)}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="info-wrap" v-if="showType=='orderInfo'&&showCartInfo">
            <div class="order-info-wrap">
              <div class="wrap-tit">收入明细</div>
              <div class="order-info">
                <table>
                  <tr class="head">
                    <th style="width:33.3%;">名称</th>
                    <th style="width:33.3%;">金额</th>
                    <th style="width:33.3%;">优惠</th>
                  </tr>
                  <tr>
                    <td style="width:33.3%;">商品费</td>
                    <td style="width:33.3%;">{{(orderInfo.productAmount).toFixed(2)}}</td>
                    <td style="width:33.3%;">{{(orderInfo.productDiscount).toFixed(2)}}</td>
                  </tr>
                  <tr>
                    <td style="width:33.3%;">包间费</td>
                    <td style="width:33.3%;">{{Number(Number(orderInfo.transaction.roomAmount)-Number(orderInfo.transaction.roomDiscount)).toFixed(2)}}</td>
                    <td style="width:33.3%;">{{(orderInfo.transaction.roomDiscount).toFixed(2)}}</td>
                  </tr>
                  <tr>
                    <td style="width:33.3%;">服务费</td>
                    <td style="width:33.3%;">{{Number(Number(orderInfo.transaction.serviceAmount)-Number(orderInfo.transaction.serviceDiscount)).toFixed(2)}}</td>
                    <td style="width:33.3%;">{{(orderInfo.transaction.serviceDiscount).toFixed(2)}}</td>
                  </tr>
                  <tr>
                    <td style="width:33.3%;">手动优惠</td>
                    <td style="width:33.3%;">{{(orderInfo.order.allHandDiscount).toFixed(2)}}</td>
                    <td style="width:33.3%;">--</td>
                  </tr>
                </table>
              </div>
            </div>
            <!-- <div class="order-info-wrap" v-if="type=='orderInfo'&&orderInfo.thirdCoupon">
              <div class="wrap-tit">第三方卡券</div>
              <div class="order-info">
                <table>
                  <tr class="head">
                    <th style="width:25%;">名称</th>
                    <th style="width:25%;">券码</th>
                    <th style="width:25%;">金额</th>
                    <th style="width:25%;">抵扣金额</th>
                  </tr>
                  <tr>
                    <td style="width:25%;">{{channelVal[orderInfo.thirdCoupon.channel]}}</td>
                    <td style="width:25%;">{{orderInfo.thirdCoupon.channelCode}}</td>
                    <td style="width:25%;">{{(orderInfo.thirdCoupon.couponAmount).toFixed(2)}}</td>
                    <td style="width:25%;">{{(orderInfo.thirdCoupon.couponDiscount).toFixed(2)}}</td>
                  </tr>
                </table>
              </div>
            </div> -->
            <div class="order-info-wrap">
              <div class="wrap-tit">商品消费清单</div>
              <div class="order-info">
                <table>
                  <tr class="head">
                    <th style="width:12.5%;">名称</th>
                    <th style="width:12.5%;">数量</th>
                    <th style="width:12.5%;">单价</th>
                    <th style="width:12.5%;">金额</th>
                    <th style="width:12.5%;">点单员工</th>
                    <th style="width:12.5%;">状态</th>
                    <th style="width:25%;">点单时间</th>
                  </tr>
                  <tr v-for="(item,index) in orderInfo.order.items" :key="index">
                    <td style="width:12.5%;">{{item.productName}}</td>
                    <td style="width:12.5%;">{{item.quantity}}</td>
                    <td style="width:12.5%;">{{item.onePrice}}</td>
                    <td style="width:12.5%;">{{item.dealPrice}}</td>
                    <td style="width:12.5%;">{{item.createName}}</td>
                    <td style="width:12.5%;">{{modeInfo[orderInfo.order.mode]}}</td>
                    <td style="width:25%;">{{new Date(item.addTime).Format('yyyy-MM-dd hh:mm:ss')}}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="order-info-wrap">
              <div class="wrap-tit">计时商品消费清单</div>
              <div class="order-info">
                <table>
                  <tr class="head">
                    <th style="width:15%;">名称</th>
                    <th style="width:15%;">计时规则</th>
                    <th style="width:12.5%;">金额</th>
                    <th style="width:12.5%;">点单员工</th>
                    <th style="width:15%;">计时时间</th>
                    <th style="width:25%;">点单时间</th>
                  </tr>
                  <tr v-for="(item,index) in orderInfo.productTime" :key="index">
                    <td style="width:15%;">{{item.productTimeName}}</td>
                    <td style="width:15%;">{{item.ruleName}}</td>
                    <td style="width:12.5%;">{{item.amount}}</td>
                    <td style="width:12.5%;">{{item.createName}}</td>
                    <td style="width:15%;">{{item.time}}</td>
                    <td style="width:25%;">{{new Date(item.addTime).Format('yyyy-MM-dd hh:mm:ss')}}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="order-info-wrap">
              <div class="wrap-tit">包间费清单</div>
              <div class="order-info">
                <table>
                  <tr class="head">
                    <th style="width:20%;">包间名</th>
                    <th style="width:20%;">开始时间</th>
                    <th style="width:20%;">入座时长</th>
                    <th style="width:20%;">计费规则</th>
                    <th style="width:20%;">包间费</th>
                  </tr>
                  <tr>
                    <td style="width:20%;">{{`${orderInfo.transaction.partitionName}-${orderInfo.transaction.numName}`}}</td>
                    <td style="width:20%;">{{orderInfo.transaction.beginTime | dateForGradePage}}</td>
                    <td style="width:20%;">{{orderInfo.transaction.inTime}}</td>
                    <td style="width:20%;">{{orderInfo.transaction.rulesName}}</td>
                    <td style="width:20%;">{{orderInfo.transaction.roomAmount}}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="order-info-wrap">
              <div class="wrap-tit">付款信息</div>
              <div class="order-info">
                <table>
                  <tr class="head">
                    <th style="width:50%;">支付方式</th>
                    <th style="width:50%;">金额</th>
                  </tr>
                  <tr>
                    <td style="width:50%;">{{channelType[orderInfo.order.channel]}}</td>
                    <td style="width:50%;">{{(orderInfo.order.amount).toFixed(2)}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="info-wrap" v-if="showType=='exchangeInfo'&&showCartInfo">
            <div class="order-info-wrap">
              <div class="wrap-tit">分类销售统计</div>
              <div class="order-info">
                <div class="for-goods">
                  <div class="head">
                    <div class="span" style="width:33.333%;">商品分类</div>
                    <div class="span" style="width:33.333%;">数量</div>
                    <div class="span" style="width:33.333%;">应收金额</div>
                  </div>
                  <div v-for="(it,idx) in nowExcInfo.itemDetails" class="goods-detail" :class="nowSelIndex==idx?'act':''" :key="idx">
                    <div class="detail-tit" @click.stop="showGoodsDetail(it,idx)" style="cursor:pointer;">
                      <div class="detail-tit-span" style="width:33.333%;text-align:left;padding-left:15px;"><i class="arrow iconfont icon-sanjiaoxing" style="vertical-align: middle;font-size:10px;margin-right:5px;"></i><span style="vertical-align: middle;font-size:16px;">{{it.typeName}}</span></div>
                      <div class="detail-tit-span" style="width:33.333%;">{{it.qty}}</div>
                      <div class="detail-tit-span" style="width:33.333%;">{{it.amount.toFixed(2)}}</div>
                      <div v-for="(item,index) in itemDetail" :key="index" class="goods" @click.stop="">
                        <div class="goods-span" style="width:33.33%;cursor:pointer;"><span>{{item.name}}</span></div>
                        <div class="goods-span" style="width:33.33%;">{{item.qty}}</div>
                        <div class="goods-span" style="width:33.33%;">{{item.amount.toFixed(2)}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="info-wrap" v-if="showType=='empSalesInfo'&&showCartInfo">
            <div class="order-info-wrap">
              <div class="wrap-tit">详情</div>
              <div class="order-info">
                <table>
                  <tr class="head">
                    <th style="width:50%;">名称</th>
                    <th style="width:50%;">金额</th>
                  </tr>
                  <tr>
                    <td style="width:50%;">会员充值</td>
                    <td style="width:50%;">{{(nowEmpSalesInfo.memberCharge).toFixed(2)}}</td>
                  </tr>
                  <tr>
                    <td style="width:50%;">总销售</td>
                    <td style="width:50%;">{{Number(nowEmpSalesInfo.salesTotal).toFixed(2)}}</td>
                  </tr>
                  <tr>
                    <td style="width:50%;">会员消费</td>
                    <td style="width:50%;">{{Number(nowEmpSalesInfo.totalMember).toFixed(2)}}</td>
                  </tr>
                  <tr>
                    <td style="width:50%;">推荐会员数</td>
                    <td style="width:50%;">{{nowEmpSalesInfo.memberCount}}</td>
                  </tr>
                  <tr>
                    <td style="width:50%;">总开台次数</td>
                    <td style="width:50%;">{{nowEmpSalesInfo.openNum}}</td>
                  </tr>
                  <tr>
                    <td style="width:50%;">预定次数</td>
                    <td style="width:50%;">{{nowEmpSalesInfo.bookNum}}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="order-info-wrap">
              <div class="wrap-tit">商品销售列表</div>
              <div class="order-info">
                <div class="for-goods">
                  <div class="head">
                    <div class="span" style="width:33.333%;">商品分类</div>
                    <div class="span" style="width:33.333%;">数量</div>
                    <div class="span" style="width:33.333%;">应收金额</div>
                  </div>
                  <div v-for="(it,idx) in nowEmpSalesInfo.items" class="goods-detail" :key="idx">
                    <div class="detail-tit" @click.stop="showGoodsDetail(it,idx)" style="cursor:pointer;">
                      <div class="detail-tit-span" style="width:33.333%;text-align:left;padding-left:15px;"><i class="arrow iconfont icon-sanjiaoxing" style="vertical-align: middle;font-size:10px;margin-right:5px;"></i><span style="vertical-align: middle;font-size:16px;">{{it.name}}</span></div>
                      <div class="detail-tit-span" style="width:33.333%;">{{it.qty}}</div>
                      <div class="detail-tit-span" style="width:33.333%;">{{it.amount.toFixed(2)}}</div>
                      <div v-for="(item,index) in it.items" :key="index" class="goods" @click.stop="">
                        <div class="goods-span" style="width:33.33%;cursor:pointer;"><span>{{item.name}}</span></div>
                        <div class="goods-span" style="width:33.33%;">{{item.qty}}</div>
                        <div class="goods-span" style="width:33.33%;">{{item.amount.toFixed(2)}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="info-wrap" v-if="showType=='packageTotalSales'&&showCartInfo">
            <div class="order-info-wrap">
              <div class="wrap-tit">商品列表</div>
              <div class="order-info">
                <table>
                  <tr class="head">
                    <th style="width:25%;">序号</th>
                    <th style="width:25%;">商品名</th>
                    <th style="width:25%;">数量</th>
                  </tr>
                  <tr v-for="(item,index) in nowPackageTotalSalesInfo.itemQties" :key="index">
                    <td style="width:25%;">{{index+1}}</td>
                    <td style="width:25%;">{{item.productName}}</td>
                    <td style="width:25%;">{{item.qty}}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="order-info-wrap">
              <div class="wrap-tit">商品消费清单</div>
              <div class="order-info">
                <table>
                  <tr class="head">
                    <th style="width:10%;">序号</th>
                    <th style="width:18%;">金额</th>
                    <th style="width:18%;">数量</th>
                    <th style="width:18%;">台桌名</th>
                    <th style="width:16%;">操作员</th>
                    <th style="width:20%;">时间</th>
                  </tr>
                  <tr v-for="(item,index) in nowPackageTotalSalesInfo.resList" :key="index">
                    <td style="width:18%;">{{index+1}}</td>
                    <td style="width:18%;">{{item.amount.toFixed(2)}}</td>
                    <td style="width:18%;">{{item.qty}}</td>
                    <td style="width:18%;">{{item.numName}}</td>
                    <td style="width:16%;">{{item.createName}}</td>
                    <td style="width:20%;">{{item.addTime|naSecFilterDate}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="info-wrap" v-if="showType=='deskSalesInfo'&&showCartInfo">
            
            <div class="order-info-wrap">
              <div class="wrap-tit">商品消费清单</div>
              <div class="order-info">
                <table>
                  <tr class="head">
                    <th style="width:10%;">序号</th>
                    <th style="width:18%;">商品名</th>
                    <th style="width:18%;">金额</th>
                    <th style="width:18%;">数量</th>
                    <th style="width:16%;">操作员</th>
                    <th style="width:20%;">时间</th>
                  </tr>
                  <tr v-for="(item,index) in nowDeskSalesInfo.orderItems" :key="index">
                    <td style="width:10%;">{{index+1}}</td>
                    <td style="width:18%;">{{item.productName}}</td>
                    <td style="width:18%;">{{item.dealPrice.toFixed(2)}}</td>
                    <td style="width:18%;">{{item.quantity}}</td>
                    <td style="width:16%;">{{item.createName}}</td>
                    <td style="width:20%;">{{item.addTime|dateForGradePage}}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="order-info-wrap">
              <div class="wrap-tit">包间费清单</div>
              <div class="order-info">
                <table>
                  <tr class="head">
                    <th style="width:15%;">包间名</th>
                    <th style="width:20%;">开始时间</th>
                    <th style="width:20%;">结束时间</th>
                    <th style="width:15%;">入座时长</th>
                    <th style="width:15%;">计费规则</th>
                    <th style="width:15%;">包间费</th>
                  </tr>
                  <tr>
                    <td style="width:15%;">{{nowDeskSalesInfo.numName}}</td>
                    <td style="width:20%;">{{nowDeskSalesInfo.begin | dateForGradePage}}</td>
                    <td style="width:20%;">{{nowDeskSalesInfo.end | dateForGradePage}}</td>
                    <td style="width:15%;">{{nowDeskSalesInfo.totalTime}}</td>
                    <td style="width:15%;">{{nowDeskSalesInfo.rulesName?nowDeskSalesInfo.rulesName:'--'}}</td>
                    <td style="width:15%;">{{nowDeskSalesInfo.totalRoomAmount}}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="order-info-wrap">
              <div class="wrap-tit">付款信息</div>
              <div class="order-info">
                <table>
                  <tr class="head">
                    <th style="width:33.333%;">序号</th>
                    <th style="width:33.333%;">支付方式</th>
                    <th style="width:33.333%;">金额</th>
                  </tr>
                  <tr v-for="(ite,indx) in nowDeskSalesInfo.channel" :key="indx">
                    <td style="width:33.333%;">{{indx+1}}</td>
                    <td style="width:33.333%;">{{channelType[ite.channel]}}</td>
                    <td style="width:33.333%;">{{ite.channel?Number(ite.amount).toFixed(2):''}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="add-or-pay-wrap" v-if="showType=='vipConsume'&&showCartInfo">
        <span class="total-fee">
          合计:
          <b>{{(Number(vipConsumeInfo.order.amount)).toFixed(2)}}</b>元
        </span>
      </div>
      <div class="add-or-pay-wrap" v-if="showType=='deskSalesInfo'&&showCartInfo">
        <span class="total-fee">
          合计:
          <b>{{(Number(nowDeskSalesInfo.totalAmount)+Number(nowDeskSalesInfo.totalRoomAmount)).toFixed(2)}}</b>元
        </span>
      </div>
      <div class="add-or-pay-wrap" v-if="showType=='orderInfo'&&showCartInfo">
        <span class="total-fee">
          合计:
          <b>{{(Number(orderInfo.order.amount)).toFixed(2)}}</b>元
        </span>
        <!-- <div class="add-or-pay" v-if="!orderInfo.order.antiEnabled&&orderInfo.order.mode!=1&&orderInfo.order.mode!=2">
          <button class="go-pay" @click="goBackPay">反结账</button>
        </div>
        <div class="add-or-pay" v-if="showCartInfo&&orderInfo.order.mode==2">
          <button class="go-pay" @click="goRealPay">销账</button>
        </div> -->
        <!-- <div class="add-or-pay" v-if="showType=='secondActivity'&&showCartInfo">
          <button class="go-pay" @click="">销账</button>
        </div> -->
      </div>
      <div class="add-or-pay-wrap" v-if="showType=='secondActivity'&&showCartInfo&&(secondInfo.promotionType=='ing'||secondInfo.promotionType=='no')">
        <!-- <div class="add-or-pay" v-if="!orderInfo.order.antiEnabled&&orderInfo.order.mode!=1&&orderInfo.order.mode!=2">
          <button class="go-pay" @click="goBackPay">反结账</button>
        </div>
        <div class="add-or-pay" v-if="showCartInfo&&orderInfo.order.mode==2">
          <button class="go-pay" @click="goRealPay">销账</button>
        </div> -->
        <div class="add-or-pay" >
          <button class="go-pay" style="background:#d99e4c" @click="cancelActivity">取消活动</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["showCartInfo","secondInfo","nowSelName","begin","end","mobile","storeId","vipInfo","showType","vipConsumeInfo","orderInfo","nowExcInfo","nowPackageTotalSalesInfo","nowDeskSalesInfo","nowEmpSalesInfo"],
  data() {
    return {
      salesGoodsInfo:{},
      formInline:{
        startTime:"",
        endTime:""
      },
      totalElementsForSales:0,
      nowPageForSales:1,
        nowPage:1,
        pageSize:10,
        pageSizeForSales:10,
        goodsInfoForSecond:{},
      typeOptions:{
            "discount":"折扣",
            "reduce":"减免金额",
        },
      nowSelIndex:-1,
        itemDetail:[],
        modeInfo:{
          0:"正常",
          1:"免单",
          2:"挂单",
          3:"反结账单"
        },
        titInfo:{"vipChargeInfo":"会员充值详情","vipConsume":"会员消费详情","exchangeInfo":"销售详情","packageTotalSales":"详情","deskSalesInfo":'详情',"empSalesInfo":'业绩详情'},
        channelType: { // 结算方式
				// ALIPAY: '支付宝',
				// CASH: '现金',
				// WECHATPAY: '微信',
				// MEMBER : '会员支付',
				// WECHATPAY_CASH : '线下微信',
				// ALIPAY_CASH : '线下支付宝',
				"CASH": "现金",
				"ALIPAY": "支付宝",
				"WECHATPAY": "微信",
				"UNIONPAY": "银联",
				"pay.weixin.micropay":"微信刷卡",
				"pay.wechat.micropay":"微信刷卡",
				"pay.alipay.micropay":"支付宝刷卡",
				"pay.jdpay.micropay":"京东刷卡",
				"pay.qq.micropay":"QQ钱包刷卡",
				"pay.shiming.micropay":"会员卡",
				"pay.unionpay.micropay":"银联支付",
				"pay.bestpay.micropay":"翼支付",
				"pay.weixin.native":"微信扫码",
				"pay.wechat.native":"微信扫码",
				"pay.alipay.native":"支付宝扫码",
				"ALIPAY_CASH":"支付宝线下",
				"WECHATPAY_CASH":"微信线下",
				"COUPON":"优惠券",
				"MEMBER":"会员",
        "pay.wechat.jspay":"微信网页支付",
        "pay.alipay.jspay":"支付宝网页支付",
			},
    }
  },
  watch:{
    showCartInfo(val){
      if(!val){
        this.showType = "";
      }else if(this.showType == 'secondActivity' && val){
        this.getGoodsInfo();
      }
    },
    nowPage(val){
      this.getGoodsInfo();
    },
    nowPageForSales(val){
      this.getSlesInfo();
    }
  },
  methods: {
    cancelActivity(){
      this.$http({
            url:"dp/cancel",
            method:"GET",
            params:{
              id:this.secondInfo.id,
            }
        }).then(res=>{
          this.$message({
              message: '操作成功',
              customClass: 'success'
          });
          this.$emit("closeCartInfo");
        });
    },
    handleCurrentChangeForSales(val) {
        console.log(`当前页: ${val}`);
        this.nowPageForSales = val;
    },
    handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.nowPage = val;
    },
    onSubmit(){
      this.getSlesInfo();
    },
    getSlesInfo(){
      if(((new Date(this.formInline.endTime)).getTime() - (new Date(this.formInline.startTime)).getTime()) > 1000*60*60*24*35){
              this.$message({
                  message: '只能查询35天内的数据',
                  customClass: 'error'
              })
              return;
      }
      if(this.formInline.startTime!=='' && this.formInline.endTime!==''){
        if(new Date(this.formInline.startTime)>new Date(this.formInline.endTime)){
              this.$message({
                  message: '结束时间不能比开始时间小',
                  customClass: 'error'
              })
              return;
          }
      }else if(String(this.formInline.startTime)=="" || String(this.formInline.endTime)==""){
        this.$message({
            message: '请选择时间',
            customClass: 'error'
        })
        return;
      }
        this.$http({
            url:"dp/sales/list",
            method:"GET",
            params:{
                promotionId:this.secondInfo.id,
                begin:new Date(this.formInline.startTime).Format("yyyy-MM-dd hh:mm:ss"),
                end:new Date(this.formInline.endTime).Format("yyyy-MM-dd hh:mm:ss"),
                page:this.nowPageForSales - 1,
                size:this.pageSizeForSales
            }
        }).then(res=>{
          this.salesGoodsInfo = res.data;
          this.totalElementsForSales = res.data.totalElements;
        });
    },
    getGoodsInfo(){
        this.$http({
            url:"dp/product/list",
            method:"GET",
            params:{
                promotionId:this.secondInfo.id,
                page:this.nowPage - 1,
                size:this.pageSize
            }
        }).then(res=>{
          this.goodsInfoForSecond = res.data;
          this.totalElements = res.data.totalElements;
        });
    },
    formatTimeRange(item){
        if(item.beginHour && item.endHour){
            return `${item.beginHour}至${item.endHour}`;
        }else{
            return '';
        }
    },
    formatTime(item){
        if(item.timeType == "forever"){
            return '永久有效';
        }else if(item.timeType == "custom"){
            return `${new Date(item.beginTime).Format("yyyy-MM-dd")}至${new Date(item.endTime).Format("yyyy-MM-dd")}`;
        }
    },
    formatDiscount(item){
        if(item.discountType == "discount"){
            return `${item.discount / 10}折`;
        }else if(item.discountType == "reduce"){
            return `${item.reduceAmount / 100}元`;
        }
    },
    closeCartInfo() {
      this.nowSelIndex=-1;
        this.itemDetail=[];
      this.$emit("closeCartInfo", "");
    },
    showGoodsDetail(it,idx){
      // console.log($(".goods-detail")[idx]);
      // if(!$($(".goods-detail")[idx]).hasClass('act')){
      //   // $($(".goods-detail")[idx]).addClass("act");
      //   $($(".goods-detail")[idx]).find(".arrow").addClass("bot");
      // }else{
      //   // $($(".goods-detail")[idx]).removeClass("act");
      //   $($(".goods-detail")[idx]).find(".arrow").removeClass("bot");
      // }
      let beginTime = new Date(this.begin).Format("yyyy-MM-dd hh:mm:ss");
      let endTime = new Date(this.end).Format("yyyy-MM-dd hh:mm:ss");
      if(idx == this.nowSelIndex){
        this.nowSelIndex = -1;
        return;
      }
      this.nowSelIndex = idx;
      this.$http({
        url:"get-total-itemDetails",
        method:"GET",
        params:{
          begin:beginTime,
          end:endTime,
          mobile:this.mobile,
          typeName:it.typeName,
          storeId:this.storeId
        }
      }).then(res=>{
        // this.$nextTick(()=>{
        //   this.nowExcInfo.itemDetails[idx].itemDetail = res.data;
        // })
        if(!res.data.length){
          this.$message({
            message:"暂无数据",
            customClass: 'error'
          })
        }
        this.itemDetail = res.data;
      })
      
    }
  },
  mounted(){
    
  },
  updated(){
    
  }
};
</script>

<style lang="scss" scoped>
@import "./cartInfo.scss";
</style>



// WEBPACK FOOTER //
// cartInfo.vue?94fa696c